import * as React from 'react';
import CanvasImagePainter from '@xfe-team/canvas-image-painter';
import cx from 'classnames';
import { delay } from '../../utils/common-util';
import extendAppend from '../modal/__helper__/extend-append';
import Modal from '@src/components/modal/Modal';
import { playTakePhotoAudio } from '@src/components/audio';
import styles from './index.less';

const CANVAS_CONTENT_SIZE = { width: 642, height: 1173 };

@extendAppend({ withoutDefaultWrapModal: true })
export default class TakePhoto extends React.Component {
  constructor(props) {
    super(props);
    this.onClose = this.onClose.bind(this);
    this.state = {
      isMaskVisible: false,
      visible: true,
      isCanvasVisible: false
    };
  }

  async componentDidMount() {
    const { hasAnimation, useTakePhotoAudio } = this.props;
    if (useTakePhotoAudio) {
      playTakePhotoAudio();
    }
    if (hasAnimation) {
      this.setState({
        isMaskVisible: true
      });
      //时长与whiteMask样式、shareCanvas样式同步修改
      await delay(600);
      this.setState({
        isMaskVisible: false
      });
      //时长与shareCanvas样式同步修改
      await delay(700);
      this.setState({
        isCanvasVisible: true
      });
    } else {
      await delay(700);
      this.setState({
        isCanvasVisible: true
      });
    }
  }

  async onClose() {
    this.setState({
      visible: false
    });
  }

  render() {
    const { defaultBgClassName, closeBtnClassName, hasAnimation, warnTip, tipClassName, footer, footerClassName, width, height, ...restProps } = this.props;
    const { isMaskVisible, visible, isCanvasVisible } = this.state;
    return (
      <Modal visible={visible} mask={true} className={defaultBgClassName}>
        <div className={styles.root}>
          <div className={cx(styles.canvasContent, isCanvasVisible ? styles.canvasShow : styles.canvasHide)}>
            <div className={cx(closeBtnClassName, styles.closeBtn)} onClick={this.onClose} />
            <div
              className={styles.canvasImg}
              style={{
                width: `${(width / CANVAS_CONTENT_SIZE.width) * 100}%`,
                height: `${(height / CANVAS_CONTENT_SIZE.height) * 100}%`
              }}
            >
              <CanvasImagePainter className={hasAnimation ? styles.shareCanvas : ''} width={width} height={height} {...restProps} />
            </div>
            <div className={cx(styles.tipText, tipClassName)}>{warnTip}</div>
            {/* 弹窗底部自定义内容槽（2026-09-20 需求）：可选 ReactNode（如海报分享弹窗的「复制分享链接」按钮），
                仅声明布局占位、不声明业务视觉；不传时渲染输出与既有调用方完全一致 */}
            {footer ? <div className={cx(styles.footerSlot, footerClassName)}>{footer}</div> : null}
          </div>
          <div className={isMaskVisible ? styles.whiteMaskShow : styles.whiteMaskHide}>
            <div className={styles.whiteMask} />
          </div>
        </div>
      </Modal>
    );
  }
}
